export enum SurrenderSwitchStep {
  Property,
  Energy,
  Consent,
  Summary,
  Confirmation,
}
